import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
const Appcontext = React.createContext({})

const AppProvider = ({children}) => {
  const [token, settoken] = useState("");
  const contextValue = useMemo(() => ({ token, settoken }), [token]);
  return(
    <Appcontext.Provider value={contextValue}>
      {children}
    </Appcontext.Provider>
  )
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export { Appcontext, AppProvider }